export const defaultState = {
  myActivities: [],
  myContracts: [],
  submissions: [],
  fiscalYears: [],
};
